import { useUser } from "model/user/UserContext";
import { useCallback } from "react";
import usersApi from "../api/users";
import authApi from "api/auth";

const useUserInitializer = () => {
  const { updateUser, updateIsUserFetched } = useUser();

  return useCallback(
    async function userInitializer() {
      try {
        const user = await usersApi.fetchLoggedUser();
        updateUser(() => user);
        return user;
      } catch (error: any) {
        if (error?.response?.status !== 401) {
          updateIsUserFetched(true);
          return null;
        } else {
          try {
            await authApi.refreshAccessToken();
            const user = await usersApi.fetchLoggedUser();
            updateUser(() => user);
            return user;
          } catch {
            updateIsUserFetched(true);
            return null;
          }
        }
      }
    },
    [updateUser, updateIsUserFetched],
  );
};

export default useUserInitializer;
